import httpClient from '../../api/axios-httpclient';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import i18n from '@/i18n/i18n';
import AcceptCheckingResultAPI from '../../api/AcceptCheckingResultAPI';

export default {
	// Chấp nhận địa chỉ, tên trên hóa đơn
	updateCheckingResult: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: AcceptCheckingResultAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/multicheckingresult`,
				data: payload
			},
			true
		);
		return res;
	}
};
